import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { Entity } from '../../models/entities/entity.model';

@Injectable()
export class EntityService {

    private _entitiesChosenSource = new Subject<{ 'entities': Entity[], 'apiUrl': string }>();

    entitiesChosen$ = this._entitiesChosenSource.asObservable();

    constructor() { }

    setChosenEntities(entities: Entity[], apiUrl: string) {
        this._entitiesChosenSource.next({ entities: entities, apiUrl: apiUrl });
    }
}
